<template>
  <div class="wrap_404">
    <div>
      <img src="./404.png" alt="404"/>
      <p>页面丢失！</p>
      <div v-if="goBack" class="btn" @click="gogo">{{goBackTxt}} <i class="el-icon-right"></i></div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ky404',
  props:{
    goBack: {
      type: Boolean,
      default: true
    },
    goBackTxt: {
      type: String,
      default: '回到首页'
    }
  },
  methods: {
    gogo() {
      this.$emit('goHome')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap_404 {
  height: 100%;
  display: flex;
  justify-items: center;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  text-align: center;
  h1{
    font-size: 200px;
    line-height: 1em;
    padding: 0;
    margin: 0;
  }
  img {
    display: block;
    width: 500px;
    margin: 30px 0;
  }
  p {
    width: 100%;
    font-size: 20px;
    color: #666;
  }
  .btn{
    display: inline-block;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: 4px;
    color: rgb(97, 184, 255);
    &:hover{
      color: rgb(59, 166, 253);
      background-color: rgba(59, 166, 253, 0.137);
    }
  }
}
</style>



// WEBPACK FOOTER //
// packages/404/index.vue